export default {
      id: "Icon--triangleDown-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--triangleDown",
      toString: function () {
        return this.url;
      }
    }